import { ErnotsConfig } from "../../ErnotsConfig";
import { Anchor } from "../RequestRespectingInputs";

export const HomeExplanations =
{
    about: 
    <>
        <p>
            The purpose of this site is to help you learn any language you want.
            Specifically, it does this by letting you read text in your native language, in parallel with a translation into the language you want to learn.
        </p>
        <div>
            Features:
            <ul style={{margin: 0}}>
                <li>
                    Create a machine translation of any document ("book", as I've been calling them), and then read it alongside the original, aligned by sentence.
                </li>
                <li>
                    Bookmark your place in the book, so you can read from where you left off.
                    (This might even be useful without translation.)
                </li>
                <li>
                    Add custom online dictionaries to look up any word you need help with. Highlight the word in the text, and then click the link to open the dictionary.
                </li>
                <li>
                    Change the display order of the languages to suit your learning needs. 
                    <ol>
                        <li>
                            If you're a beginner, you might put your native language first, and read the translation when you already know what it says.
                        </li>
                        <li>
                            Or, you might want to try reading the foreign language first, and use your native version as a fallback.
                        </li>
                        <li>
                            Or, again, you might put your native language first, and try to mentally translate it yourself, before checking what Google thinks it should be.
                        </li>
                    </ol>
                </li>
                <li>
                    Read in as many parallel languages as you want. Not just two, but possibly even three or four. Sky's the limit.
                </li>
                <li>
                    Although by default, books are created using a plain text editor, there's also a rich text editor available.
                    You can copy text from a website, and {ErnotsConfig.AppName} will display the pictures or other elements that don't work with plain text. (The pictures are NOT hosted here, so the site needs to allow cross-origin embedding.)
                </li>
            </ul>
        </div>
    </>,
    instructions:
    <fieldset>
        <p>Now that you've logged in, it's time to start learning!</p>

        <p>As has been mentioned before, the purpose of this site is helping you hone your skill in a foreign language
        by reading books, articles or anything else in that language, side by side with that same text in your native tongue.
        So let's talk about how you can get started.</p>

        <ul>
            <li>
                <b><Anchor to={'books'}>Books</Anchor></b>:
                The focal point of the site, where the books you <Anchor to={'/book/edit'}>created</Anchor> are listed.
                See there for further instructions.
            </li>
            <li>
                <b><Anchor to={'languages'}>Languages</Anchor></b>: These are the languages that can be used with books. Every book needs at least one language, the source language, but can be translated into one or several others. Many languages are already listed, but you can add more for your own use.
            </li>
            <li>
                <b><Anchor to={'abbreviations'}>Abbreviations</Anchor></b>: 
                This program works by splitting book text into sentences. If your text is getting split on abbreviations because they have a period at the end, this page can help. You can also add abbreviations while creating the book itself.
            </li>
            <li>
                <b><Anchor to={'dictlinks'}>Dictionaries</Anchor></b>:
                A dictionary is a button that appears under each sentence, or under the translation in the specified language.
                Highlight a word, then click the button, and a window will open with a definition.
            </li>
            <li>
                <b><Anchor to={'arbitrarytext'}>Translate Arbitrary Text</Anchor></b>:
                A simple utility to quickly translate a large amount of text.
            </li>
        </ul>
    </fieldset>
};